import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right.ts";
import useTranslation from "@babackapp/translations/use-translation";
import { ShoppingBagIcon, TruckIcon } from "@heroicons/react/24/outline";
import {
  FileTextIcon,
  LightningBoltIcon,
  PersonIcon,
} from "@radix-ui/react-icons";
import { NavigationSectionItem } from "./section.tsx";

export default function SecondaryNavigation() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const hasRight = useViewerHasAtLeastAdminRights();

  if (!shop || !hasRight) return null;

  const navItems = [
    {
      name: t("sidebar.shopInformation"),
      href: `/shops/${shop.id}/settings/shop-informations`,
      icon: <ShoppingBagIcon className="w-4 h-4" />,
    },
    {
      name: t("sidebar.customerPortal"),
      href: `/shops/${shop.id}/settings/customer-portal`,
      icon: <PersonIcon className="w-4 h-4" />,
    },
    {
      name: t("sidebar.carriers"),
      href: `/shops/${shop.id}/settings/carriers`,
      icon: <TruckIcon className="w-4 h-4" />,
    },
    {
      name: t("sidebar.integrations"),
      href: `/shops/${shop.id}/settings/integrations`,
      icon: <LightningBoltIcon className="w-4 h-4" />,
    },
  ];

  const isShopifyTestWebsite = shop.email.includes("shopify.com");
  if (!isShopifyTestWebsite) {
    navItems.push({
      name: t("sidebar.billing"),
      href: `/shops/${shop.id}/settings/billing`,
      icon: <FileTextIcon className="w-4 h-4" />,
    });
  }

  return (
    <>
      {navItems.map((navItem) => (
        <NavigationSectionItem
          key={navItem.name}
          to={navItem.href}
          label={navItem.name}
          icon={navItem.icon}
        />
      ))}
    </>
  );
}
